import React from 'react';
import { Menu } from 'lucide-react';
export function Header() {
  return <header className="h-16 bg-white border-b border-gray-200 flex items-center px-6 sticky top-0 z-40" data-id="element-323">
      <button className="p-2 mr-4 text-gray-500 hover:bg-gray-100 rounded-md transition-colors" data-id="element-324">
        <Menu size={20} data-id="element-325" />
      </button>
      <h1 className="text-xl font-semibold text-gray-900" data-id="element-326">Market Insights</h1>
    </header>;
}